import { createAuthClient } from "better-auth/react";

/**
 * better-auth client for the Pro SPA. Talks to the SAME auth backend as the
 * consumer app (`/api/auth/*`), so advisors and consumers share one user table.
 *
 * baseURL resolution mirrors the consumer client (client/src/lib/auth-client):
 *   1. VITE_API_ORIGIN when set at build time (the documented path).
 *   2. Else in a production build, the known API host — never the Pages origin.
 *   3. In dev, window.location.origin so the Vite proxy (/api → :3000) handles
 *      it same-origin (cookies just work, no CORS).
 */
export const authClient = createAuthClient({
  baseURL:
    import.meta.env.VITE_API_ORIGIN
    || (import.meta.env.PROD ? "https://api.biedradar.nl" : undefined)
    || (typeof window !== "undefined" ? window.location.origin : "http://localhost:5174"),
  fetchOptions: {
    credentials: "include",
  },
});

export const { useSession, signIn, signUp, signOut } = authClient;

export type Session = ReturnType<typeof useSession>["data"];
